// extracted by mini-css-extract-plugin
export default {"uploadBtn":"Dateien_uploadBtn__+fU6W","uploadContainer":"Dateien_uploadContainer__x+ag2"};